<template>
    <div class="content">

      <!--<div v-if="!paymentType" style="text-align: center;">
         <el-button type="warning" @click="paymentBtn">微信/支付寶支付</el-button>
         <br>
         <br><br><br><br>
         <el-button type="danger" @click="paymentType=true">藍新支付</el-button>
      </div>-->
      <!--<div v-if="paymentType">-->
      <div>
        <div style="padding-top: 20px;"></div>
      
        <div style="display: none;"></div>
        <div ref="alipayWeb" v-html="alipay" style="display: none;"></div>
        <div class="moble-form-class" v-if="isMobile">

            <div style="text-align: center;">
              <h1>{{ server_name }}</h1>
              <p style="color: red;">充值比例：1 : {{ scale }}</p>
               
            </div>

            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" class="demo-ruleForm">
               <el-form-item label="提示"><span style="color: crimson;font-size: xx-small;">(支付前請先搜索賬號是否存在，以免失敗)</span></el-form-item>
                <el-form-item label="賬號" prop="game_account_name">
                    <el-input v-model="ruleForm.game_account_name" placeholder="請輸入遊戲賬號" >
                      <el-button slot="append" icon="el-icon-search" @click="queryAccount"></el-button>
                   
                    </el-input> 
                       
                </el-form-item>
                <el-form-item label="角色" prop="game_char_id" v-if="accounts.length > 0">
                  <el-tag type="success" v-for="(tag,index) in accounts" :key="index">{{ tag.game_char }}</el-tag>&nbsp;&nbsp;
                </el-form-item>
                <!--<el-form-item label="確認賬號" prop="agin_game_account_name">
                    <el-input v-model="ruleForm.agin_game_account_name"></el-input>     
                </el-form-item>-->
                <el-form-item label="金額" prop="amt">
                    <el-input-number v-model="ruleForm.amt" :min="4" :max="100000000" :step="4" @change="queryJF"></el-input-number>
                    <span v-if="qjf.integral">可獲得余額：<el-tag type="danger">{{ qjf.integral }}</el-tag>點</span>
                </el-form-item>
                <el-form-item label="備註" prop="remark">
                    <el-input v-model="ruleForm.remark" type="textarea"  :rows="2"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="success" @click="submitForm('ruleForm')" :loading="payBtn">立即支付</el-button>
                </el-form-item>
            </el-form>

        </div>
        <div class="form-class"  v-else>

            <div style="text-align: center;">
              <h1>{{ server_name }}</h1>
              <p style="color: red;">充值比例：1 : {{ scale }}</p>
               
            </div>

            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" class="demo-ruleForm">
               <el-form-item label="提示"><span style="color: crimson;font-size: xx-small;">(支付前請先搜索賬號是否存在，以免失敗)</span></el-form-item>
                <el-form-item label="賬號" prop="game_account_name">
                    <el-input v-model="ruleForm.game_account_name" placeholder="請輸入遊戲賬號" >
                      <el-button slot="append" icon="el-icon-search" @click="queryAccount"></el-button>
                   
                    </el-input> 
                       
                </el-form-item>
                <el-form-item label="角色" prop="game_char_id" v-if="accounts.length > 0">
                  <el-tag type="success" v-for="(tag,index) in accounts" :key="index">{{ tag.game_char }}</el-tag>&nbsp;&nbsp;
                </el-form-item>
                <!--<el-form-item label="確認賬號" prop="agin_game_account_name">
                    <el-input v-model="ruleForm.agin_game_account_name"></el-input>     
                </el-form-item>-->
                <el-form-item label="金額" prop="amt">
                    <el-input-number v-model="ruleForm.amt" :min="4" :max="100000000" :step="4" @change="queryJF"></el-input-number>
                    <span v-if="qjf.integral">可獲得余額：<el-tag type="danger">{{ qjf.integral }}</el-tag>點</span>
                </el-form-item>
                <el-form-item label="備註" prop="remark">
                    <el-input v-model="ruleForm.remark" type="textarea"  :rows="2"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="success" @click="submitForm('ruleForm')" :loading="payBtn">立即支付</el-button>
                </el-form-item>
            </el-form>

        </div>
      </div>

    </div>
</template>
<script>
import {Form, Message} from 'element-ui';
  export default {
    data() {
      return {
        isMobile: false,
        ruleForm: {
          serviceId:'',
          service_id:'',
          usdt:1,
          remark:'',
          game_account_name:'',
          user_type:0,
          amt:0
        },
        qjf:{},
        accounts:[],
        paymentType:false,
        payBtn:false,
        tip:'請掃碼支付',
        tipFlag:true,
        options:[],
        scale : 1,
        orderNo:'',
        server_name:'',
        alipay:'',
        out_pay_url:'',
        rules: {
          amt: [
            { required: true, message: '請填寫金額', trigger: 'blur' },
            
          ],
          game_account_name: [
            { required: true, message: '請輸入遊戲賬號', trigger: 'blur' },
          ],
        }
      };
    },
    created(){
              this.isMobile = window.innerWidth < 768;
        let self = this;
        var url = window.location.href ;             //獲取當前url
        var cs={};
        if(url.indexOf('#') > -1 && url.indexOf('?') > -1 &&  url.indexOf('&') > -1){ 
            var dz_url = url.split('#')[0];                //獲取#/之前的字符串
            var csstr = dz_url.split('?')[1];                //獲取?之後的參數字符串
            var cs_arr = csstr.split('&');                    //參數字符串分割為數組
       
            for(var i=0;i<cs_arr.length;i++){         //遍歷數組，拿到json對象
              if(cs_arr[i]){
                if(cs_arr[i].split('=')){
                  cs[cs_arr[i].split('=')[0]] = cs_arr[i].split('=')[1] 
                }
              }
            }
        }
    
        if(cs.service_id){ 
           //這樣就拿到了參數中的數據
            self.ruleForm.serviceId = cs.service_id;   
     
        }else{
            self.ruleForm.serviceId = '44f714b60a064f738b1dd56a9c16ad4c'
        }
        self.ruleForm.service_id = self.ruleForm.serviceId;    
        this.getParam();
    },
    methods: {
      paymentBtn(){
        window.open(this.out_pay_url, "_blank");

       // window.location.href= "http://app.sxzbd.com/pay/tbNg";
      },
      queryAccount(){
        let self = this;
        self.postRequest('/game/characters_list',self.ruleForm).then(resp =>{
                 if(resp.err >= 500){
                    Message.error({message: resp.msg});
                    return;
                 }
                 self.accounts = resp.data;
        })
      },
      queryJF(){
        let self = this;
        this.ruleForm.price = self.ruleForm.amt;
        self.postRequest('/order/integral_price',self.ruleForm).then(resp =>{
                 if(resp.err >= 500){
                    Message.error({message: resp.msg});
                    return;
                 }
                 self.qjf = resp.data;
        })
      },
      submitForm(formName) {
          let self = this;
          self.payBtn = true;
          self.$refs[formName].validate((valid) => {
          if (valid) {
            self.postRequest('/bluenew/pay',self.ruleForm).then(resp =>{
                 self.payBtn=false;
                 if(resp.err >= 500){
                    Message.error({message: resp.msg});
                    return;
                 }
                 self.alipay = resp.data;
                 console.log(resp.data);
                 self.$nextTick(()=>{
                      self.$refs.alipayWeb.children[0].submit();
                  });
             

            })
          } else {
            self.payBtn=false;
            console.log('error submit!!');
            return false;
          }
        });
      },
      getParam(){
          let self = this;
  
        console.log("this.ruleForm.service_id:"+self.ruleForm.service_id);

        self.postRequest('/game/servers_detail',self.ruleForm).then(resp =>{
                 if(resp.err >= 500){
                    Message.error({message: resp.msg});
                    return;
                 }
                 self.serverDetail = resp.data;
                self.out_pay_url = resp.data.out_pay_url;
                self.scale = resp.data.scale;
                document.title = resp.data.service_name;
                self.server_name = resp.data.service_name;
            })

       

      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      
  
      handleClose(done) {
        this.$confirm('確認關閉？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
    },
  }
</script>
<style scoped>
    .content{
     
        margin-top: 50px;
        width: 100%;
          /* 水平垂直都居中 */
      display: flex;
      justify-content: center; /* 水平居中 */
      align-items: center;     /* 垂直居中 */
   
      
    }
    .form-class{
        padding-top: 50px;
        padding-left: 100px;
        padding-right: 100px;
        width: 100%;
        height: 600px;
        max-height: 800px;
        background-color: rgb(161, 194, 203);
        border-radius: 20px;
     
    }
    .moble-form-class{
      padding-top: 30px;
       width: 100%;
        height: 500px;
        max-height: 800px;
        background-color: rgb(55, 155, 153);
        border-radius: 20px;
    }


</style>